/**
 * Overrides de APIs para desarrollo local (`npm run local`).
 * Agregá acá más servicios a medida que los corras en tu máquina.
 *
 * Clave = segmento del path luego de API_BASE_URL (ej. "business", "fleet").
 * Valor = URL completa del servicio en local (incluye el path del servicio).
 */
export const LOCAL_API_OVERRIDES = {
  business: 'http://localhost:3050/business',
  atc: 'http://localhost:3002/atc',
  // fleet: 'http://localhost:3051/fleet',
  // inventory: 'http://localhost:3052/inventory',
  // scheduler: 'http://localhost:3003/scheduler',
} as const;

export type LocalApiService = keyof typeof LOCAL_API_OVERRIDES;

export const isLocalApisEnabled = () =>
  import.meta.env.VITE_LOCAL_APIS === 'true';

export const resolveApiUrl = (
  service: string,
  remoteUrl: string
): string => {
  if (!isLocalApisEnabled()) return remoteUrl;

  const override =
    LOCAL_API_OVERRIDES[service as LocalApiService] ?? undefined;

  return override ?? remoteUrl;
};
